import { render } from "./ClientsPayments.vue?vue&type=template&id=75b0bc4f"
import script from "./ClientsPayments.vue?vue&type=script&lang=js"
export * from "./ClientsPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__